import {SESSION_COOKIE_NAME} from "../features/project-drawings/features/editor/constants";

export const isInIframe = (): boolean => {
	try {
		return window.self !== window.top;
	} catch {
		return true;
	}
};

/**
 * Premium deliberately nulls window.opener on its popup (reverse-tabnabbing mitigation),
 * so a legitimate new-tab launch can't be detected via window.opener. TAKEOFFS_COOKIE
 * is only ever set by the backend's /auth/simpro handler after a real OAuth2 token is
 * validated, so its presence proves this session actually came through that flow.
 */
export const hasSimproSession = (): boolean => {
	return document.cookie
		.split(";")
		.some((cookie) => cookie.trim().startsWith(`${SESSION_COOKIE_NAME}=`));
};

/**
 * Whether the app is running as its own tab rather than embedded in Premium's iframe.
 * Only meaningful once hasSimproSession() has already gated access, since a standalone
 * tab and Premium's iframe are the only two legitimate launch shapes.
 */
export const isStandalone = (): boolean => {
	return !isInIframe();
};
